import React from 'react';
import { Link } from 'react-router-dom';

import titolo from "../images/titolo_guida.png";

import img1 from "../images/guida/1.png";
import img2 from "../images/guida/2.png";
import img3 from "../images/guida/3.png";
import img4 from "../images/guida/4.png";
import img5 from "../images/guida/5.png";
import img6 from "../images/guida/6.png";

// Stili CSS in JS
const styles = {
  container: {
    lineHeight: "1.6",
    maxWidth: "800px",
    margin: "0 auto",
    padding: "20px",
	textAlign: "left",
  },
  menu: {
    marginBottom: "40px",
    textAlign: "center",
  },
  
  imgguida: {
	display: "block",
	maxWidth : "80%",
    margin: "auto",
    borderRadius: "25px",
  },
  
  title: {
    fontSize: "26px",
    fontWeight: "bold",
    marginBottom: "20px",
  },
  buttonGroup: {
    display: "flex",
    flexDirection: "column",
    gap: "12px",
    alignItems: "center",
  },
  button: {
	fontFamily: 'FuturaLightBt',
    display: "inline-block",
    padding: "10px 18px",
    backgroundColor: "#edeae6", 
    color: "#000",
    textDecoration: "none",
    borderRadius: "8px",
    fontWeight: "bold",
	fontSize: "20px",
    transition: "background-color 0.3s ease",
  },
  section: {
    marginBottom: "40px",
  },
  subtitle: {
    fontSize: "30px",
    fontWeight: "600",
    marginBottom: "12px",
  },
  backLink: {
    display: "block",
    marginTop: "20px",
	marginRight: "20px",
    color: "#000",
    textDecoration: "none",
    fontWeight: "bold",
	textAlign: "right"
  },
  list: {
    marginTop: "12px",
    marginBottom: "12px",
    paddingLeft: "20px",
  },

};


function Guida() {
  return (
    <div style={styles.container}>
      {/* Menu iniziale */}
      <div id="start" style={styles.menu}>
		<h1>Guida alla App</h1>
        <div style={styles.buttonGroup}>
          <a href="#introduzione" style={styles.button}>Introduzione</a>
          <a href="#realtime" style={styles.button}>Come funziona il Real Time</a>
          <a href="#upload" style={styles.button}>Come funziona l’Upload</a>
          <a href="#problemi" style={styles.button}>Risoluzione Problemi</a>
        </div>
      </div>

      {/* Introduzione */}
      <section id="introduzione" style={styles.section}>
        <h2 style={styles.subtitle}>Introduzione</h2>
        <p>
          <b>Il Catalogo Artlinea è interattivo</b> e grazie alla tecnologia di lettura OCR è in grado di
          permettere all’utente una visione completa dei dettagli di qualsiasi articolo presente.
        </p>
		<img style={styles.imgguida} src={img1} />
        <p>
          <b>Su ogni pagina del catalogo è presente un QR code che indirizzerà l’utente verso
          l’applicazione</b> in grado di leggere, tramite la fotocamera, ogni singolo codice prodotto.
        </p>
		<img style={styles.imgguida} src={img2} />
        <p>
          <b>Inquadrando</b> con il telefono <b>il codice</b> su carta, apparirà sullo schermo il codice
          dell’articolo che non solo fornirà il prezzo aggiornato, ma attraverso un click sul
          <b>pulsante “Dettagli” indirizzerà l’utente verso la scheda prodotto dell’articolo</b>, fornendo
          ulteriori informazioni sulle varianti, carature, personalizzazioni e permettendo la visione
          di ulteriori immagini o video del prodotto.
        </p>
		<img style={styles.imgguida} src={img3} />
        <p>
          Grazie a questo innovativo approccio, i clienti possono rimanere <b>sempre aggiornati su dettagli e prezzi degli articoli.</b>
        </p>
        <a href="#start" style={styles.backLink}>⬆ Torna all’inizio</a>
      </section>

      {/* Real Time */}
      <section id="realtime" style={styles.section}>
        <h2 style={styles.subtitle}>Come funziona il Real Time</h2>
        <p>
          Una volta autorizzato l’uso della fotocamera da parte della App, possiamo scegliere fra due modalità: <b>Real Time</b> o Upload.
        </p>
        <p>
          <b>La modalità Real Time aprirà</b>, previa scelta della fotocamera, <b>la schermata dell’applicazione che consentirà la lettura live dei codici.</b>
        </p>
        <p>
          <b>La fase di scelta della fotocamera</b> è importante in caso il vostro smartphone abbia più di una camera. Quella migliore è la fotocamera “Back”. Qualora l’immagine inquadrata risultasse poco nitida consigliamo di provare a cambiare fotocamera.
        </p>
        <p>
          <b>Con la fotocamera aperta inquadriamo quindi un codice ed aspettiamo che l’applicazione trovi l’articolo.</b> Una volta individuato l’articolo sarà possibile aprire la scheda prodotto ed accedere ad ulteriori informazioni tramite il pulsante <b>“Dettagli” oppure eseguire un’ulteriore scansione</b> tramite l’apposito pulsante.
        </p>
		<img style={styles.imgguida} src={img4} />
        <a href="#start" style={styles.backLink}>⬆ Torna all’inizio</a>
      </section>

      {/* Upload */}
      <section id="upload" style={styles.section}>
        <h2 style={styles.subtitle}>Come funziona l’Upload</h2>
        <p>
          La modalità di <b>Upload</b> consente di <b>scattare una foto e caricarla automaticamente sull’applicazione oppure di caricare foto precedentemente scattate</b> scegliendole dalla galleria dello smartphone.
        </p>
		<img style={styles.imgguida} src={img5} />
        <p>
          In modalità Upload <b>si consiglia di scattare il singolo gioiello desiderato</b> poiché una foto con più articoli potrebbe risultare difficile da interpretare per l’applicazione.
        </p>
        <p>
          Ricordiamo inoltre che <b>in alcuni telefoni non è disponibile lo scatto da fotocamera ma solo il caricamento della foto dalla galleria</b>.
        </p>
        <a href="#start" style={styles.backLink}>⬆ Torna all’inizio</a>
      </section>

      {/* Risoluzione Problemi */}
      <section id="problemi" style={styles.section}>
        <h2 style={styles.subtitle}>Risoluzione Problemi</h2>
        <p>
          Durante la consultazione del Catalogo Interattivo potrebbero presentarsi alcuni problemi. <b>Qui forniamo alcune soluzioni:</b>
        </p>
        <ul style={styles.list}>
          <li><b>Concedere l’autorizzazione</b> alla app <b>all’utilizzo della fotocamera</b> è necessario per il corretto funzionamento.</li>
          <li><b>Effettuare la scelta della fotocamera migliore</b> è fondamentale per consentire alla app di leggere in modo chiaro i codici. La fotocamera da scegliere sarà quella che consente una <b>buona messa a fuoco del codice.</b></li>
          <li><b>Scegliere sempre un luogo luminoso e privo di ombre</b> dove utilizzare il catalogo e la app in modo da consentire alla fotocamera un’inquadratura libera da ostacoli ed il più possibile chiara.</li>
        </ul>
		
		<p>Per aprire correttamente il link alla app inquadrando il QR code consigliamo l’uso dei seguenti strumenti:</p>
		<ul style={styles.list}>
          <li><b>fotocamera</b> interna del telefono</li>
          <li><b>una app che consente la lettura QR code</b> con link diretto al browser (consigliamo Chrome o Safari)</li>
          <li><b>Google Lens</b></li>
        </ul>
		
        <p>
          Per qualsiasi dubbio o problema con l’applicazione <b>Artlinea è a vostra completa disposizione.</b>
        </p>
		<img style={styles.imgguida} src={img6} />
        <a href="#start" style={styles.backLink}>⬆ Torna all’inizio</a>
      </section>
    </div>
  );
}

export default Guida;
